import React from 'react';

const CardSkeleton = ({ variant = 'default' }) => {
  if (variant === 'horizontal') {
    return (
      <div className="bg-card rounded-lg shadow-elevation-2 overflow-hidden animate-pulse">
        <div className="flex flex-col sm:flex-row">
          <div className="w-full sm:w-48 h-48 sm:h-auto bg-muted flex-shrink-0" />
          <div className="flex-1 p-4 space-y-3">
            <div className="h-6 bg-muted rounded w-3/4" />
            <div className="h-4 bg-muted rounded w-full" />
            <div className="h-4 bg-muted rounded w-5/6" />
            <div className="grid grid-cols-2 gap-3 mt-4">
              <div className="h-4 bg-muted rounded" />
              <div className="h-4 bg-muted rounded" />
            </div>
            <div className="flex gap-2 mt-4">
              <div className="h-10 bg-muted rounded flex-1" />
              <div className="h-10 bg-muted rounded flex-1" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 overflow-hidden animate-pulse h-full flex flex-col">
      <div className="w-full h-48 bg-muted flex-shrink-0" />
      <div className="p-4 flex-1 flex flex-col space-y-3">
        <div className="h-6 bg-muted rounded w-3/4" />
        <div className="h-4 bg-muted rounded w-full" />
        <div className="h-4 bg-muted rounded w-5/6" />
        <div className="space-y-2 mt-4">
          <div className="h-4 bg-muted rounded" />
          <div className="h-4 bg-muted rounded" />
        </div>
        <div className="flex items-center justify-between pt-4 border-t border-border mt-auto">
          <div className="h-8 bg-muted rounded w-20" />
          <div className="h-10 bg-muted rounded w-32" />
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;